import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { KycSubmitInput } from '@monigo/shared';
import { callFunction } from '../../lib/api/client.js';
import { qk } from '../../lib/api/queryKeys.js';

export interface KycStatus {
  has_completed_kyc: boolean;
  latest_submission: {
    id: string;
    status: 'pending' | 'approved' | 'rejected';
    rejection_reason: string | null;
    created_at: string;
  } | null;
}

export function useKycStatus() {
  return useQuery({
    queryKey: qk.kycStatus,
    queryFn: () => callFunction<KycStatus>('kyc-status'),
  });
}

export function useSubmitKyc() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: KycSubmitInput) => callFunction('kyc-submit', { body: input }),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.kycStatus }),
  });
}
